<template>
  <div>
		<winning-numbers-sidebar :open.sync="sidebarOpen" :results="externalLotteriesResults"></winning-numbers-sidebar>
		<v-btn id="external-results-btn" @click="sidebarOpen = !sidebarOpen" style="z-index: 4">
			Winning Numbers
		</v-btn>
    <v-row>
      <v-img contain height="200" :src="require('assets/static/img/logo/superlotto_white.png')"></v-img>
    </v-row>
    <v-row justify="center">
      <v-col cols="auto">
        <v-btn @click="scrollToStream">
          See it live
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        lg="4"
        sm="6"
        cols="12"
        v-for="result in results"
        :key="`${result.date}-${result.sortition.id}`"
      >
        <v-card class="result-card">
          <v-card-text>
            <result-display :result="result"> </result-display>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-responsive :aspect-ratio="16 / 9">
      <iframe
        v-if="channelName && channelName.length > 0"
        id="frame"
        :src="
          `https://player.twitch.tv/?channel=${channelName}&parent=suplotto.net`
        "
        frameborder="0"
        scrolling="no"
        allowfullscreen="true"
      >
      </iframe>
    </v-responsive>
    <h2 class="text-center">Good luck!</h2>
  </div>
</template>

<script>
import ResultDisplay from "./ResultDisplay.vue";
import BaseStream from "../BaseStream.js";

export default {
  name: "Stream",
  components: {
    ResultDisplay
  },
  extends: BaseStream
};
</script>

<style scoped lang="scss">
#frame {
  width: 75vh;
  height: 60vh;
}

div.v-card.result-card.v-sheet {
  background-color: rgba(#2b55bc, 0.5);
  padding: 5px;
}

#frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
